export default __webpack_public_path__ + "static/media/SEC1990.34I-41263_-24601_0.a74a98bb.jpg";